import {Injectable, Component} from '@angular/core';

declare var window;

@Injectable()
export class SystemPaths {

    private basePath = window._env.baseURL;
    
    private baseApiPath = window._env.baseApiURL;

    private baseTitle: string = "MySportsFeeds";

    public STRIPE_API_KEY: string = window._env.STRIPE_API_KEY;

    public FACEBOOK_APP_ID: string = window._env.FACEBOOK_APP_ID;

    public TWITTER_KEY: string = window._env.TWITTER_KEY;

    private getRelativePath(relPath) {
        return this.basePath + relPath;
    }

    constructor() {
	}

    public windowTitle(suffix) {
        let title:string = this.baseTitle;
        if (suffix) {
            title += " :: " + suffix;
        }

        return title;
    }

    public imageUrlBase() {
        let pathStr:string = this.basePath;
        if (pathStr.indexOf("index.php") > 0) {
            pathStr = pathStr.substring(0, pathStr.indexOf("index.php"));
        }

        return pathStr + 'packages/mysportsfeeds/images';
    }

    public sampleUrlBase(apiVersion) {
        let pathStr:string = this.baseApiPath;

        return pathStr + apiVersion.path + '/sample/pull';
    }

    public feedUrlBase(apiVersion) {
        let pathStr:string = this.baseApiPath;

        return pathStr + apiVersion.path + '/pull';
    }

    public feedXsdBase(apiVersion) {
        let pathStr:string = this.baseApiPath;

        return pathStr + apiVersion.path + '/xsd';
    }

    public home() {
        return this.basePath;
    }

    public register() {
        return this.getRelativePath('register');
    }

    public editAvatar() {
        return this.getRelativePath('profile/avatar');
    }

    public editSettings() {
        return this.getRelativePath('profile/edit');
    }

    public login() {
        return this.getRelativePath('login');
    }

    public logout() {
        return this.getRelativePath('login/logout');
    }

    public profile(userId) {
        let pathStr:string = this.getRelativePath('profile');
        if (userId) {
            pathStr += "/" + userId;
        }

        return pathStr;
    }

    public members() {
        return this.getRelativePath('members');
    }

    public memberBenefits() {
        return this.getRelativePath('member-benefits');
    }

    public dataFeeds() {
        return this.getRelativePath('data-feeds');
    }

    public subscriptions() {
        return this.getRelativePath('data-feeds/subscriptions');
    }

    public feedList(leagueAbbr) {
        return this.getRelativePath('data-feeds/' + leagueAbbr.toLowerCase() + '/feedlist');
    }

    public feedSummary(leagueAbbr, feedAbbr) {
        return this.getRelativePath('data-feeds/' + leagueAbbr.toLowerCase() + '/feedlist/feedsummary?feed=' + feedAbbr.toLowerCase());
    }

    public playerList(leagueAbbr) {
        return this.getRelativePath('browse/' + leagueAbbr.toLowerCase() + '/players');
    }

    public addPlayer(leagueAbbr) {
        return this.getRelativePath('browse/' + leagueAbbr.toLowerCase() + '/players/add');
    }

    public playerView(leagueAbbr, playerId) {
        return this.getRelativePath('browse/' + leagueAbbr.toLowerCase() + '/players/view?id=' + playerId);
    }

    public playerEdit(leagueAbbr, playerId) {
        return this.getRelativePath('browse/' + leagueAbbr.toLowerCase() + '/players/edit?id=' + playerId);
    }

    public playerInjury(leagueAbbr, playerId) {
        return this.getRelativePath('browse/' + leagueAbbr.toLowerCase() + '/players/injury?id=' + playerId);
    }

    public stats(leagueAbbr) {
        return this.getRelativePath('browse/' + leagueAbbr.toLowerCase() + '/stats');
    }

    public standings(leagueAbbr) {
        return this.getRelativePath('browse/' + leagueAbbr.toLowerCase() + '/standings');
    }

    public teamView(leagueAbbr, teamId) {
        return this.getRelativePath('browse/' + leagueAbbr.toLowerCase() + '/standings/teamsummary?id=' + teamId);
    }

    public schedule(leagueAbbr) {
        return this.getRelativePath('browse/' + leagueAbbr.toLowerCase() + '/schedule');
    }

    public addGame(leagueAbbr) {
        return this.getRelativePath('browse/' + leagueAbbr.toLowerCase() + '/schedule/add');
    }

    public gameSummary(leagueAbbr, gameId, rotationNum = "0", rotationTotalNum = "0") {
        let urlStr = this.getRelativePath('browse/' + leagueAbbr.toLowerCase() + '/schedule/gamesummary?id=' + gameId);
        if ( rotationNum != "0" && rotationTotalNum != "0" ) {
            urlStr += "&rotationnum=" + rotationNum + "&rotationtotal=" + rotationTotalNum;
        }

        return urlStr;
    }

    public gameScheduleEdit(leagueAbbr, gameId) {
        return this.getRelativePath('browse/' + leagueAbbr.toLowerCase() + '/schedule/editgameschedule?id=' + gameId);
    }

    public playerStatsValidation(league: any, season: any, fetchLatest: boolean) {
        let urlStr: string = "/plugin/sport/" + league.sport.abbreviation.toLowerCase() + "/league/" + league.id + "/" +
            "season/" + season.id + "/playerstats/differences?latest=" + fetchLatest;
        return this.baseApiPath() + urlStr;
    }

    public teamStatsValidation(league: any, season: any, fetchLatest: boolean) {
        let urlStr: string = "/plugin/sport/" + league.sport.abbreviation.toLowerCase() + "/league/" + league.id + "/" +
            "season/" + season.id + "/teamstats/differences?latest=" + fetchLatest;
        return this.baseApiPath() + urlStr;
    }

}
